import * as React from 'react'

import {makeEditable} from '@/common/utils'
import {Grid} from '@/components/Grid'
import Heading from '@/components/Heading'
import RichText from '@/components/RichText/Richtext'

const ContentClassic = ({headingTag, heading, content, _editable}) => {
  const HeadingTag = headingTag || 'p'

  return (
    <section {...makeEditable(_editable)}>
      <Grid>
        <div className='col-span-full lg:col-start-3 lg:col-end-11'>
          <HeadingTag className='space-y-4'>
            <Heading heading={heading} className='block' />
          </HeadingTag>
          <div className='my-20'>
            <RichText richtext={content} />
          </div>
        </div>
      </Grid>
    </section>
  )
}

export default ContentClassic
